import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  Stack,
  Typography
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Colors, { BIGrey } from "../../assets/helpers";
import {
  FETCH_CLIENT_EMP_JOBS_2,
  FETCH_CLIENT_WORK_PACKAGE_TRACKING_STATUS,
  SAVE_CLIENT_EMPLOYEES_JOBS
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import QrScanner from "./QrScanner";

// qr button
const QrButton = ({ text, onClick = () => { } }) => {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackage(
    multiLanguageData?.ClientWorkPackage || {}
  );
  const { TEXT_SCAN_QR_CODE } = LANGUAGE;
  const AccentColor = selectedClientData?.AccentColor;
  return (
    <Button
      startIcon={<QrCodeScannerIcon />}
      onClick={onClick}
      sx={{
        backgroundColor: AccentColor,
        color: "#fff"
      }}>
      {text || TEXT_SCAN_QR_CODE}
    </Button>
  );
};

export default function Workpackage() {
  const { selectedClientData, loginData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackage(
    multiLanguageData?.ClientWorkPackage || {}
  );
  const { TEXT_NO_JOBS_AVAILABLE } = LANGUAGE;
  const [jobList, setJobList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [qrScannerOpen, setQrScannerOpen] = useState(false);
  const navigation = useNavigate();

  const fetchJobs = useCallback(async () => {
    try {
      setLoading(true);
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };

      const res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS_2, obj, loginData?.accessToken);

      if (res?.status === 200) {
        const data = res?.data?.data;
        setJobList(data || []);
      }
    } catch (error) {
      console.log("fetchJobs->Error Fetching Client Employee Job: ", error);
    } finally {
      setLoading(false);
    }
  }, [
    selectedClientData?.ClientEmployeeId,
    loginData?.accessToken,
    loginData?.userInformation?.UserId
  ]);

  useEffect(() => {
    if (selectedClientData?.ClientEmployeeId && loginData?.accessToken) {
      fetchJobs();
    }
  }, [selectedClientData?.ClientEmployeeId, loginData?.accessToken, fetchJobs]);

  const handleQrScan = () => {
    setQrScannerOpen(true);
  };

  const handleAddJobToUser = async (scannedData) => {
    navigation(`${scannedData?.workPackageId}`);
    if (!scannedData?.jobId) {
      alert("Invalid QR code");
      return;
    }
    handleQrScannerClose();
    const payload = {
      UserId: Number(loginData?.userInformation?.UserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          Id: 0,
          ClientEmployeeId: Number(selectedClientData?.ClientEmployeeId),
          ClientJobId: Number(scannedData?.jobId),
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        }
      ]
    };

    try {
      const res = await Postrequestcall(
        SAVE_CLIENT_EMPLOYEES_JOBS,
        payload,
        loginData?.accessToken
      );
      if (res?.data?.status) {
        fetchJobs();
      }
    } catch (error) { }
  };

  const handleQrScanResult = (result) => {
    try {
      const scannedData = JSON.parse(result?.data);

      if (scannedData.clientId !== selectedClientData?.ClientId) {
        alert(
          "This job is assigned to a different client. Please scan a job under your client, or switch to the correct client to proceed."
        );
        return;
      }
      if (!scannedData?.jobId) {
        alert("Invalid QR code");
        return
      } else {
        handleAddJobToUser(scannedData);
      }

    } catch (error) {
      alert("Invalid QR code");
      console.error("Error processing QR scan result:", error);
    }
  };

  const handleQrScannerClose = () => {
    setQrScannerOpen(false);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Stack sx={{ gap: "10px", padding: "10px" }}>
      <Box justifyContent={"flex-end"} display={"flex"}>
        <QrButton onClick={handleQrScan} />
      </Box>
      <Stack>
        {jobList.length > 0 ? (
          jobList.map((item, index) => (
            <CustomAccoridan key={item?.id || index} item={item} index={index} />
          ))
        ) : (
          <Typography variant="body1" color="textSecondary" textAlign="center" py={4}>
            {TEXT_NO_JOBS_AVAILABLE}
          </Typography>
        )}
      </Stack>

      {/* QR Scanner Modal */}
      {qrScannerOpen && (
        <QrScanner
          open={qrScannerOpen}
          onClose={handleQrScannerClose}
          onScanResult={handleQrScanResult}
        />
      )}
    </Stack>
  );
}

const CustomAccoridan = ({ item, index }) => {
  const { selectedClientData, loginData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackage(
    multiLanguageData?.ClientWorkPackage || {}
  );
  const { TEXT_UNKNOWN_JOB, TEXT_NO_WORK_PACKAGES_AVAILABLE } = LANGUAGE;
  const AccentColor = selectedClientData?.AccentColor;

  const [workPackageData, setWorkPackageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  const fetchWorkPackage = useCallback(async () => {
    try {
      setLoading(true);

      const obj = {
        JobId: item?.clientJobId,
        ClientEmployeeId: selectedClientData?.ClientEmployeeId
      };

      const res = await Postrequestcall(
        FETCH_CLIENT_WORK_PACKAGE_TRACKING_STATUS,
        obj,
        loginData?.accessToken
      );
      if (res?.status === 200) {
        const data = res?.data?.data;
        setWorkPackageData(data || []);
      }
    } catch (error) {
      console.log("fetchWorkPackage->Error Fetching Work Package: ", error);
    } finally {
      setLoading(false);
    }
  }, [item?.id]);

  useEffect(() => {
    if (item?.id && loginData?.accessToken) {
      fetchWorkPackage();
    }
  }, [item?.id, loginData?.accessToken, fetchWorkPackage]);

  return (
    <Accordion
      key={index}
      defaultExpanded={true}
      sx={{
        "&.MuiPaper-root": {
          margin: "0px"
        }
      }}>
      <AccordionSummary
        sx={{
          padding: "10px 15px",
          "& .MuiAccordionSummary-content": {
            padding: "0px",
            margin: "0px"
          },
          "& .Mui-expanded": {
            padding: "0px",
            margin: "0px"
          }
        }}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header">
        <Stack>
          <Typography fontWeight={"bold"}>{`${item?.jobName || TEXT_UNKNOWN_JOB}`}</Typography>
          <Typography
            sx={{
              color: BIGrey
            }}>
            {item?.jobCode || "N/A"}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        {loading ? (
          <Box display="flex" justifyContent="center" py={2}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Stack
            sx={{
              borderRadius: "10px"
            }}>
            {workPackageData.length > 0 ? (
              workPackageData.map((workPackageItem, workPackageIndex) => {
                const lastIndex = workPackageData.length - 1;
                return (
                  <>
                    {workPackageItem?.isTracking ? (
                      <div
                        key={workPackageItem?.id || workPackageIndex}
                        onClick={() => {
                          navigation(`${workPackageItem?.id}`, { state: workPackageItem });
                        }}
                        style={{
                          padding: "10px",
                          paddingLeft: "5px",
                          cursor: "pointer",
                          border: `2px solid ${AccentColor}`,
                          borderLeft: `10px solid ${AccentColor}`,
                          borderRadius: "8px"
                        }}>
                        <Stack>
                          <Typography fontWeight={"bold"}>{workPackageItem?.name}</Typography>
                          <span>
                            <Chip
                              size="small"
                              label={workPackageItem?.statusName}
                              sx={{
                                padding: "5px 2px",
                                borderRadius: "5px"
                              }}
                            />
                          </span>
                        </Stack>
                      </div>
                    ) : (
                      <div
                        key={workPackageItem?.id || workPackageIndex}
                        onClick={() => {
                          navigation(`${workPackageItem?.id}`, { state: workPackageItem });
                        }}
                        style={{
                          padding: "10px",
                          border: `2px solid ${Colors.Gray94}`,
                          borderTop: workPackageIndex != 0 ? "none" : `2px solid ${Colors.Gray94}`,
                          borderBottomRightRadius: lastIndex == workPackageIndex ? "8px" : "0px",
                          borderBottomLeftRadius: lastIndex == workPackageIndex ? "8px" : "0px",
                          borderTopRightRadius: workPackageIndex == 0 ? "8px" : "0px",
                          borderTopLeftRadius: workPackageIndex == 0 ? "8px" : "0px",
                          cursor: "pointer",
                          paddingLeft: "15px",
                          borderBottom: workPackageData?.[workPackageIndex + 1]?.isTracking
                            ? "none"
                            : `2px solid ${Colors.Gray94}`
                        }}>
                        <Stack>
                          <Typography fontWeight={"bold"}>{workPackageItem?.name}</Typography>
                          <span>
                            <Chip
                              size="small"
                              label={workPackageItem?.statusName}
                              sx={{
                                padding: "5px 2px",
                                borderRadius: "5px"
                              }}
                            />
                          </span>
                        </Stack>
                      </div>
                    )}
                  </>
                );
              })
            ) : (
              <Box textAlign="center" py={2}>
                <Typography variant="body2" color="textSecondary">
                  {TEXT_NO_WORK_PACKAGES_AVAILABLE}
                </Typography>
              </Box>
            )}
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
